const aboutUs = {
    title: 'Over Ons',
    subtitle: 'Ontdek de passie en ervaring die "La Dolce Vita" de perfecte keuze maken voor jouw avonturen in Abruzzo',
    breadcrumb: 'Over Ons',
    ourStory: {
        title: 'Ons Verhaal',
        paragraph1: 'Wij zijn twee vrienden geboren en getogen in Abruzzo, diep verbonden met ons land. Na jaren van reizen en ontdekkingen, besloten we een agentschap te creëren met één doel: het meest authentieke Abruzzo bekendmaken aan wie op zoek is naar een echte, meeslepende en stressvrije ervaring.',
        paragraph2: '',
        paragraph3: ''
    },
    whatWeOrganize: {
        title: 'Wat We Organiseren',
        groupTravel: 'Gepersonaliseerde groepsreizen',
        authenticExperiences: 'Authentieke ervaringen: typische keuken, trekking, dorpen, natuur, handwerk',
        wineTours: 'Wijn- en gastronomische tours met lokale producenten',
        customActivities: 'Op maat gemaakte activiteiten: voor gezinnen, koppels, groepen, bedrijven of scholen',
        completeServices: 'Gidsdiensten, vervoer en complete assistentie op het gebied'
    },
    mission: {
        title: 'Onze Missie',
        subtitle: 'Ons agentschap is ontstaan met een duidelijk doel: je helpen Abruzzo op een eenvoudige, authentieke en zorgeloze manier te beleven.\nWe kennen elke hoek van dit land—van de verborgen paden van Gran Sasso tot de geheime stranden van de Costa dei Trabocchi, van kleine wijnproducenten tot dorpsfeesten die weinig toeristen weten te vinden.',
        description: ''
    },
    values: {
        sustainability: {
            title: 'Duurzaamheid',
            description: 'We bevorderen verantwoord toerisme dat het milieu respecteert en lokale gemeenschappen ondersteunt.'
        },
        authenticity: {
            title: 'Authenticiteit',
            description: 'We bieden oprechte ervaringen die je in staat stellen de ware geest van Abruzzo te ontdekken.'
        },
        excellence: {
            title: 'Uitmuntendheid',
            description: 'We zijn toegewijd aan het leveren van superieure kwaliteitsservices en een onberispelijke klantervaring.'
        }
    },
    whyChooseUs: {
        title: 'Waarom Kiezen voor Ons',
        subtitle: 'Omdat Abruzzo niet geïmproviseerd kan worden. Het is geen regio om te bezoeken met de klok in de hand en een route gekopieerd van internet. Het is een land dat gehoord, doorkruist en gevoeld moet worden. En om dit op de juiste manier te doen, heb je iemand nodig die het echt kent.\nMet ons ben je geen gewone toerist, maar een bevoorrechte gast, begeleid door mensen die diep van deze regio houden en ervoor gekozen hebben om de schoonheid ervan te delen met wie het weet te waarderen',
        localExperience: {
            title: 'Lokale Ervaring',
            description: 'We kennen elke verborgen hoek en elke traditie van Abruzzo, omdat we hier zijn opgegroeid.'
        },
        worryFreeTravel: {
            title: 'Zorgeloos Reizen',
            description: 'Wij regelen alles: transport, hotels, restaurants, activiteiten. Jij geniet gewoon van de vakantie.'
        },
        responsibleTourism: {
            title: 'Verantwoord Toerisme',
            description: 'We werken samen met lokale realiteiten en bevorderen toerisme dat het milieu respecteert en gemeenschappen waardeert.'
        }
    },
    customerService: {
        title: 'Uitzonderlijke Klantenservice',
        subtitle: 'We zijn er altijd voor jou',
        description: 'Ons toegewijde klantenserviceteam is beschikbaar om je te helpen met elke vraag, zorg of bijzondere vraag. We geloven dat uitzonderlijke service de basis is van onvergetelijke reiservaringen.',
        responseTime: 'We reageren meestal binnen een paar uur tijdens kantooruren',
        contactUs: 'Neem Nu Contact Op',
        supportTitle: 'Klantenservice',
        veryFastAnswer: 'Zeer snelle reactie',
        personalizedAssistance: 'Gepersonaliseerde assistentie voor elke vraag',
        followUp: 'Opvolging tot volledige tevredenheid'
    },
    cta: {
        title: 'Klaar voor Je Avontuur?',
        subtitle: 'Sluit je bij ons aan en ontdek de magie van Abruzzo door authentieke en onvergetelijke ervaringen.',
        discoverTrips: 'Ontdek Onze Reizen',
        exploreActivities: 'Verken Activiteiten',
        exploreDestinations: 'Verken Bestemmingen',
        exploreCuriosities: 'Verken Curiositeiten'
    }
};

export default aboutUs;

